namespace Cfnc {
    "use strict";

    interface ICfncScrollTo extends ng.IDirective {
    }

    interface ICfncScrollToScope extends ng.IScope {
    }

    interface ICfncScrollToAttributes extends ng.IAttributes {
        cfncScrollTo: string;
        scrollSpeed?: string;
        ngClick?: any;
        clickEventAction?: string;
        scrollElement?: string; 
        scrollDirection: string;
    }

    CfncScrollTo.$inject = ["$window", "$parse"];
    function CfncScrollTo($window: ng.IWindowService, $parse: ng.IParseService): ICfncScrollTo {
        return {
            restrict: "A",
            link: link,
            
        }

        function link(scope: ICfncScrollToScope, element: ng.IAugmentedJQuery, attrs: ICfncScrollToAttributes) {
            var speed = attrs.scrollSpeed != null ? parseInt(attrs.scrollSpeed) : 500;
            var clickEvent;
            attrs.clickEventAction = attrs.clickEventAction ? attrs.clickEventAction : "before";
            
            if (attrs.ngClick) {
                clickEvent = _.clone(attrs.ngClick);
                element.off("click");
            }

            element.on('click', (e) => {
                if (attrs.clickEventAction == "before" && clickEvent) {
                    scope.$apply(clickEvent);
                }

                var elem = attrs.scrollElement ? attrs.scrollElement : "html, body";

                switch (attrs.scrollDirection) {
                    case "left":
                        $(elem).animate({
                            scrollLeft: isFinite(parseInt(attrs.cfncScrollTo)) ? attrs.cfncScrollTo : $("#" + attrs.cfncScrollTo).position().left
                        }, speed).promise().done(() => {
                            if (attrs.clickEventAction == "after" && clickEvent) {
                                scope.$apply(clickEvent);
                            }
                        });
                        break;
                    default:
                        $(elem).animate({
                            scrollTop: isFinite(parseInt(attrs.cfncScrollTo)) ? attrs.cfncScrollTo : $("#" + attrs.cfncScrollTo).position().top
                        }, speed).promise().done(() => {
                            if (attrs.clickEventAction == "after" && clickEvent) {
                                scope.$apply(clickEvent);
                            }
                        });
                        break;

                }
                

            });
            
        }
    }

    angular.module("app").directive("cfncScrollTo", CfncScrollTo);
}